import React from "react";
import { StepProps } from "../PageFormProgress";
import "./ProgressStep.scss";
import ClassNames from "classnames";
import { Tooltip } from "@SeemplicityDev/shared";

type ProgressStepProps = Pick<StepProps, "name" | "completed" | "failed"> & {
  index: number;
  active: boolean;
  isLast: boolean;
};

const ProgressStep: React.FC<ProgressStepProps> = ({
  name,
  index,
  active,
  completed,
  failed,
  isLast,
}) => {
  const getStepCircle = () => {
    if (completed && !active) {
      return <i className={"seem-icon seem-icon-checkmark"} />;
    }

    if (failed && !active) {
      return <i className={"seem-icon seem-icon-x-small"} />;
    }

    return <div className={"progress-step-number"}>{index + 1}</div>;
  };

  const classNameWrapper = ClassNames("progress-step", {
    active: active,
    completed: completed,
    failed: failed,
    last: isLast,
  });

  return (
    <div className={classNameWrapper} data-testid={`progress-step-${index}`}>
      <div className={`progress-step-top`}>
        <div
          className={"progress-step-circle"}
          data-testid={"progress-step-circle"}
        >
          {getStepCircle()}
        </div>
        {!isLast && (
          <div className={"progress-step-arrow"}>
            <div className={"progress-step-arrow-line"} />
          </div>
        )}
      </div>
      <Tooltip content={name}>
        <div className={"progress-step-bottom"}>{name}</div>
      </Tooltip>
    </div>
  );
};

export default ProgressStep;
